import React, { FC } from 'react'
import { IconBaseProps } from 'react-icon-base'
import { StyledIcon } from '.'

export const CsExternalLinkIcon: FC<IconBaseProps> = (props) => (
  <StyledIcon viewBox="0 0 1024 1024" {...props}>
    <g>
      <path d="M804.571 539.429v182.857q0 68-48.286 116.286t-116.286 48.286H164.57q-68 0-116.286-48.286T-.002 722.286V246.857q0-68 48.286-116.286T164.57 82.285h402.286q8 0 13.143 5.143t5.143 13.143v36.571q0 8-5.143 13.143t-13.143 5.143H164.57q-37.714 0-64.571 26.857t-26.857 64.571v475.429q0 37.714 26.857 64.571t64.571 26.857h475.429q37.714 0 64.571-26.857t26.857-64.571V539.428q0-8 5.143-13.143t13.143-5.143h36.571q8 0 13.143 5.143t5.143 13.143zM1024 45.714v292.571q0 14.857-10.857 25.714t-25.714 10.857-25.714-10.857L861.144 263.428 488.573 635.999q-5.714 5.714-13.143 5.714t-13.143-5.714l-65.143-65.143q-5.714-5.714-5.714-13.143t5.714-13.143l372.571-372.571L669.144 71.428q-10.857-10.857-10.857-25.714T669.144 20t25.714-10.857h292.571q14.857 0 25.714 10.857T1024 45.714z" />
    </g>
  </StyledIcon>
)

CsExternalLinkIcon.displayName = 'CsExternalLinkIcon'
